import { getNameModelUtil } from '../../../../model'
import { WORKOUT_SECTION_KEY, WORKOUT_SECTION_TYPE, WORKOUT_SECTION_TYPE_NAME } from '../../constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function isWarmUpOrStretchingWorkoutSectionUtil (instance) {
  if (!instance) {
    return false
  }
  return (
    getValueReduxUtil(instance, WORKOUT_SECTION_KEY.TYPE) ===
    WORKOUT_SECTION_TYPE.WARMUP ||
    getNameModelUtil(instance)
      .includes(WORKOUT_SECTION_TYPE_NAME[WORKOUT_SECTION_TYPE.WARMUP]) ||
    getValueReduxUtil(instance, WORKOUT_SECTION_KEY.TYPE) ===
    WORKOUT_SECTION_TYPE.STRETCHING ||
    getNameModelUtil((
      instance
    ))
      .includes(WORKOUT_SECTION_TYPE_NAME[WORKOUT_SECTION_TYPE.STRETCHING])
  )
}

export { isWarmUpOrStretchingWorkoutSectionUtil }
